import { AuthProvider } from 'ra-core';
import dataProvider from '../../dataProvider';
import {
    AppInfoInitialState,
    APP_INFO_SUCCESS,
    AuthActionTypes,
    IamListInitialState,
    IAM_LISTS_SUCCESS,
} from './types';
import { GET_ONE } from 'react-admin';

const authProvider: AuthProvider = {
    // called when the user attempts to log in
    login: () => {
        return Promise.resolve();
    },
    // called when the user clicks on the logout button
    logout: () => {
        localStorage.clear();
        return Promise.resolve();
    },
    // called when the API returns an error
    checkError: (props: any) => {
        const { status } = props;
        if (status === 401) {
            localStorage.clear();
            return Promise.reject();
        } else if (status === 403) {
            //localStorage.clear();
            // return Promise.reject({ redirectTo: '/unauthorized', logoutUser: false });
        }
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: () => {
        if (localStorage.getItem('user')) {
            return Promise.resolve();
        } else {
            return dataProvider(GET_ONE, 'api/v1/users/current-user', undefined)
                .then(
                    (result: any) => {
                        if (result.status === true) {
                            localStorage.setItem('user', JSON.stringify(result.data.user));
                            localStorage.setItem('config', JSON.stringify(result.data.config));
                            return Promise.resolve();
                        }

                        return Promise.reject();
                    },
                    (error: any) => {
                        //console.log(error);
                        return Promise.reject();
                    },
                )
                .catch((error: any) => {
                    //console.error('Error :', error);
                    return Promise.reject();
                });
        }
    },

    getIdentity: () => {
        try {
            const { id, fullName, avatar } = JSON.parse(localStorage.getItem('user') as string);
            return Promise.resolve({ id, fullName, avatar });
        } catch (error) {
            return Promise.reject(error);
        }
    },

    // called when the user navigates to a new location, to check for permissions / roles
    getPermissions: () => {
        if (localStorage.getItem('permissions')) {
            const permissions = localStorage.getItem('permissions');
            return permissions ? Promise.resolve(JSON.parse(permissions)) : Promise.reject();
        } else {
            return dataProvider(GET_ONE, 'api/v1/security/iam-policies', undefined)
                .then(
                    (result: any) => {
                        if (result.status === true) {
                            localStorage.setItem('permissions', JSON.stringify(result.data));
                            return Promise.resolve(result.data);
                        }

                        return Promise.reject();
                    },
                    (error: any) => {
                        //console.log(error);
                        return Promise.reject();
                    },
                )
                .catch((error: any) => {
                    //console.error('Error :', error);
                    return Promise.reject();
                });
        }
    },
};

export default authProvider;

export const appInfoInit: AppInfoInitialState = {
    version: '0.0.0',
};
export function appInfo(state = appInfoInit, action: AuthActionTypes) {
    switch (action.type) {
        case APP_INFO_SUCCESS:
            return action.payload?.data;
        default:
            return state;
    }
}

const iamListInitialState: IamListInitialState = {
    ALLOWED: [],
    CONDITIONAL: [],
    CONDITIONAL_STATEMENTS: [],
    DENIED: [],
};
export function iamLists(state = iamListInitialState, action: AuthActionTypes) {
    switch (action.type) {
        case IAM_LISTS_SUCCESS:
            return action.payload?.data;
        default:
            return state;
    }
}
